import { Injectable } from '@angular/core';

import { ParcelData } from '../parcelData';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { ActivatedRoute  } from '@angular/router';

import { filter,  catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class GetDataService {

  order: string;

  // private serverUrl = 'https://script.go4.eu/status/status.php?from=go4status&parcelId=';
  private serverUrl = 'https://getstatus.go4.eu/status.php?from=go4status&parcelId=';



  constructor(  private http: HttpClient,
                private route: ActivatedRoute) { }

  /** GET shipment data from the server */
  getDataFromDB(id: string): Observable<ParcelData[]> {
    return this.http.get<ParcelData[]>(this.serverUrl+id)
    .pipe(
      catchError(this.handleError<ParcelData[]>('getDataFromDB', []))
    );
  }

  /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log (`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getGetQueryParams(): string { // neviem pouzit ako service, musi byt priamo v show-status componente, inak necita spravnu URL
    this.route.queryParams //?parcelId=21032600003
    .pipe(filter(params => params.parcelId))
    .subscribe(params => {
      // console.log(params); // { order: "21032600003" }
      this.order = params.parcelId;
      // console.log('co hladam ' + this.order); // 21032600003
      }
    );

    return this.order ;

  }

  checkIfNumber (value: string)  {
    return true;
  }

  digits_count(n: number) {
    var count = 0;
    if (n >= 1) ++count;

    while (n / 10 >= 1) {
      n /= 10;
      ++count;
    }

    return count;
  }

}



// TODO - handleError


// do buducnosti mozno hladat rovno aj u partnerov - priamo tam presmerovat stranku resp. dat link, ze detaily najdete tu

//     sps
// http://t-t.sps-sro.sk/result.php?cmd=SDG_SEARCH&sprache=&sdg_landnr=703&sdg_mandnr=010&sdg_lfdnr=17948999&km_mandnr=001&kundenr=8018

// 703-010-17948999


// dpd
// https://tracking.dpd.de/status/sk_SK/parcel/06505065558508

// https://www.dhl.com/sk-sk/home/tracking/tracking-express.html?submit=1&tracking-id=9630490730


